import {TEXTAREA} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: TEXTAREA,
  attribute: 'repo_notes',
  label: {
    default: 'Repo Notes',
    short: 'Notes',
  },
});
